
import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Table,
  Button,
  Card,
  message,
} from "antd";
import {
  EditOutlined,
  SaveTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import Service from "../../service";
import { useDispatch } from "react-redux";
import { hideAuthLoader, showAuthLoader } from "../../appRedux/actions/Auth";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json"
import EditIcon from "../../assets/images/EditIcon";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";
const KarmaWeightage = () => {
  const [editId, setEditId] = useState("");
  const [flag, setFlag] = useState(false);
  const [editData, setEditData] = useState({});
  const dispatch = useDispatch()

  const [karmaSendingBalance, setkarmaSendingBalance] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 3,
  });
  const [searchText, setSearchText] = useState("");
  const [seachEnabled, setSearchEnabled] = useState(false);

  const [paginationD, setPaginationD] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [designationList, setDesignationList] = useState([]);
  const [editedData, setEditedData] = useState({});
  const [editdata, seteditedData] = useState({})

  const [editUpdateddata, seteditedUpdatedData] = useState({})

  const Search = Input.Search;

  const searchRef = useRef();

  let [editid, setEditid] = useState();
  const [edtitext, setEdittext] = useState({});

  const [tableData, setTableData] = useState([]);


  const onSearch = (value) => {
    setSearchText(value);

    setPagination({ ...pagination, current: 1 });
  };
  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };

  const handleEdit = (id) => {
    const updatedData = designationList.map((item) => {

      if (item.designationId === id) {
        return { ...item, amount: editData.amount };
      }
      return item;
    });

    setDesignationList(updatedData);
    setFlag(true);
    setEditid(id);

  };

  const updateKarmaBalanceByDesignation = async (value) => {
    try {

      let rebBody = {
        designationId: value?.designationId,
        karma_balance: value?.waffle
      }

      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.updateKarmaBalanceByDesignation,
        body: rebBody
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        getDesignationList()
        seteditedUpdatedData({})
        message.success("Amount updated successfully");
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  const handleSave = (record) => {
    const updatedRecord = editedData[record.designationId] || record;
    seteditedUpdatedData({
      designation_name: updatedRecord.designation_name,
      designationId: updatedRecord.designationId,
      waffle: updatedRecord.karma_balance ?? 0,
    })
    seteditedData(editedData)
    handleEdit(updatedRecord);
    setFlag(false);
    setEditid("");
    setEditedData({});
    updateKarmaBalanceByDesignation({
      designation_name: updatedRecord.designation_name,
      designationId: updatedRecord.designationId,
      waffle: updatedRecord.karma_sending_balance ?? 0,
    })
  };
  const columnsDesignation = [
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text, record) => (
        <span style={ { textTransform: "capitalize" } }>
          { record?.designation_name }
        </span>
      ),
    },
    {
      title: "Waffle",
      dataIndex: "waffle",
      key: "waffle",
      render: (text, record) => {
        const waffleAmount = editedData[record.designationId]?.karma_sending_balance ?? record?.karma_sending_balance ?? 0;

        return record.designationId == editid?.designationId ? (
          <Input
            value={ waffleAmount }
            onChange={ (e) =>
              setEditedData({
                ...editedData,
                [record.designationId]: { ...record, karma_sending_balance: e.target.value },
              })
            }
          />
        ) : (
          <span>{ waffleAmount }</span>
        );
      },
    },

    ...(getResource(config.RESOURCES.WAFFLE_WEIGHTAGE, ["update"])
      ? [{
        title: "Actions",
        dataIndex: "action",
        render: (text, record) => (
          <div style={ { display: "flex", flexWrap: "wrap" } }>
            { editid?.designationId === record.designationId ? (
              <>
                <Button type="link" className="edit">
                  <SaveTwoTone
                     
                    onClick={ () => handleSave(record) }
                  />
                </Button>
                <Button type="link" className="delete" onClick={ () => setEditid("") }>
                  <CloseCircleTwoTone   />
                </Button>
              </>
            ) : (
              <Button type="link" className="edit">
                <EditIcon
                   
                  onClick={ () => handleEdit(record) }
                />
              </Button>
            ) }
          </div>
        ),
      }]
      : []),
    ,
  ];



  const getDesignationList = async (values) => {
    try {
      dispatch(showAuthLoader());

      const reqBody = {
        pageNum: paginationD.current,
        pageLimit: paginationD.pageSize,
      };

      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getEmployeesKarmaSendingBalanceByDesignation,
        body: reqBody,
      });

      if (response.data && response.data.data) {
        setDesignationList(response.data.data);
        setPaginationD({
          ...paginationD,
          total: response.data.metaData.totalRecords,
          deactivetotal: response.data.metaData.totalFilteredPage,
        });
        setEditid("")
        dispatch(hideAuthLoader());
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  useEffect(() => {
    getDesignationList();
  }, [paginationD.current, paginationD.pageSize, searchText]);

  const handleTableChangeesignt = (page, filters, sorter) => {
    setPaginationD({ ...paginationD, ...page });
  };

  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is { paginationD.total > 0 ? paginationD.total : 0 }
      </label>
    );
  };
  return (
    <>
      <Card className="employee-card">
        <div className=" inout-header text-left">
          <h2> Waffle Weightage</h2>
        </div>
        <Card className="main-content-wrapper" >
          <div className="search-wrapper">


            <Search
              ref={ searchRef }
              placeholder="Search..."
              onSearch={ onSearch }
              onKeyUp={ resetSearchFilter }
              style={ { width: 200 } }
              className="mr2"
            />
          </div>
          <div className='main-table-wrapper'>
            <Table
              locale={ { emptyText: <NodataFoundIcon/> } }
              columns={ columnsDesignation }
              pagination={ {
                ...TABLE_PAGINATION,
                ...paginationD,
              } }
              footer={ getFooterDetails }
              onChange={ handleTableChangeesignt }
              dataSource={ designationList }
            />
          </div>
        </Card>
      </Card>
    </>
  );
};

export default KarmaWeightage;
